// extracted by mini-css-extract-plugin
export default {"container":"landscapeOverlay__container__IqspR","icon":"landscapeOverlay__icon__ND2Rb","text":"landscapeOverlay__text__Pnsdc","boldText":"landscapeOverlay__boldText__BL6Nw"};